
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { getSiteName } from "../api/axios";
const FooterStatic = () => {
  // console.log(user);
  return (
    <footer className="bg-white border-t py-8">
      <div className="container mx-auto px-4">
        <ul className="flex flex-wrap justify-center gap-4 text-sm text-gray-600 mb-4">
          <li><a href="/cms/about-us" className="hover:underline">About Us</a></li>
          <li><a href="/cms/terms-conditions" className="hover:underline">Terms & Conditions</a></li>
          <li><a href="/cms/privacy-policy" className="hover:underline">Privacy Policy</a></li>
          {getSiteName() === 'goertrip' && (
            <li><a href="/cms/goer-plus-tnc" className="hover:underline">Goertrip Care+ T&C</a></li>
          )}

          <li><a href="/cms/contact-us" className="hover:underline">Contact Us</a></li>
          <li><a href="/cms/faq" className="hover:underline">FAQ</a></li>
          {/* <li><a href="/cms/a-members-only-wholesale-booking-site" className="hover:underline">A Members Only Wholesale Booking Site</a></li> */}
        </ul>
        {getSiteName() !== 'clickpaytrip' && (
          <div className="mt-4 flex justify-center gap-4">
            <img src="https://www.iata.org/contentassets/3e83770142a040d688e269bb2f709b7b/iata-logo-header.svg?height=200&rmode=crop&v=20240116100112" alt="iata logo" className="h-20" />
          </div>
        )}
        {/* <div className="mt-4 flex justify-center gap-4">
          <a href="#"><Facebook className="w-5 h-5 hover:text-blue-600" /></a>
          <a href="#"><Twitter className="w-5 h-5 hover:text-blue-400" /></a>
          <a href="#"><Instagram className="w-5 h-5 hover:text-pink-500" /></a>
          <a href="#"><Linkedin className="w-5 h-5 hover:text-blue-700" /></a>
        </div> */}
      </div>
    </footer>
  )
}

export default FooterStatic